import script from "./MemoryInterpretationNotesGame.vue?vue&type=script&setup=true&lang=js"
export * from "./MemoryInterpretationNotesGame.vue?vue&type=script&setup=true&lang=js"

import "./MemoryInterpretationNotesGame.vue?vue&type=style&index=0&id=da28a010&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-da28a010"]])

export default __exports__